import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { ZONES_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_ZONE_LIST = '_LOAD_ZONE_LIST';
export const CREATE_ZONE = '_CREATE_ZONE';
export const LOAD_ZONE_BY_ID = '_LOAD_ZONE_BY_ID';
export const EDIT_ZONE_BY_ID = '_EDIT_ZONE_BY_ID';
export const DELETE_ZONE = '_DELETE_ZONE';
export const EXPORT_ZONES = '_EXPORT_ZONES';
export const IMPORT_ZONES = '_IMPORT_ZONES';
export const LOAD_ZONE_HISTORY = '_LOAD_ZONE_HISTORY';
export const LOAD_HISTORY_BY_ID = '_LOAD_HISTORY_BY_ID';

export const loadZoneList = createDeferredAction(ZONES_MODULE + LOAD_ZONE_LIST);
export const loadZoneListBegin = createDeferredAction(ZONES_MODULE + LOAD_ZONE_LIST + BEGIN);
export const loadZoneListSuccessful = createAction(ZONES_MODULE + LOAD_ZONE_LIST + SUCCESSFUL);
export const loadZoneListFailed = createAction(ZONES_MODULE + LOAD_ZONE_LIST + FAILED);

export const createZone = createDeferredAction(ZONES_MODULE + CREATE_ZONE);
export const createZoneSuccessful = createAction(ZONES_MODULE + CREATE_ZONE + SUCCESSFUL);
export const createZoneFailed = createAction(ZONES_MODULE + CREATE_ZONE + FAILED);

export const loadZoneById = createDeferredAction(ZONES_MODULE + LOAD_ZONE_BY_ID);
export const loadZoneByIdSuccessful = createAction(ZONES_MODULE + LOAD_ZONE_BY_ID + SUCCESSFUL);
export const loadZoneByIdFailed = createAction(ZONES_MODULE + LOAD_ZONE_BY_ID + FAILED);
export const loadZoneByIdClear = createDeferredAction(ZONES_MODULE + LOAD_ZONE_BY_ID + CLEAR);

export const editZoneById = createDeferredAction(ZONES_MODULE + EDIT_ZONE_BY_ID);
export const editZoneByIdSuccessful = createAction(ZONES_MODULE + EDIT_ZONE_BY_ID + SUCCESSFUL);
export const editZoneByIdFailed = createAction(ZONES_MODULE + EDIT_ZONE_BY_ID + FAILED);

export const deleteZone = createDeferredAction(ZONES_MODULE + DELETE_ZONE);
export const deleteZoneSuccessful = createAction(ZONES_MODULE + DELETE_ZONE + SUCCESSFUL);
export const deleteZoneFailed = createAction(ZONES_MODULE + DELETE_ZONE + FAILED);

export const exportZones = createDeferredAction(ZONES_MODULE + EXPORT_ZONES);
export const exportZonesSuccessful = createAction(ZONES_MODULE + EXPORT_ZONES + SUCCESSFUL);
export const exportZonesFailed = createAction(ZONES_MODULE + EXPORT_ZONES + FAILED);

export const importZones = createDeferredAction(ZONES_MODULE + IMPORT_ZONES);
export const importZonesSuccessful = createAction(ZONES_MODULE + IMPORT_ZONES + SUCCESSFUL);
export const importZonesFailed = createAction(ZONES_MODULE + IMPORT_ZONES + FAILED);

export const loadZoneHistory = createDeferredAction(ZONES_MODULE + LOAD_ZONE_HISTORY);
export const loadZoneHistorySuccessful = createAction(ZONES_MODULE + LOAD_ZONE_HISTORY + SUCCESSFUL);
export const loadZoneHistoryFailed = createAction(ZONES_MODULE + LOAD_ZONE_HISTORY + FAILED);

export const loadHistoryById = createDeferredAction(ZONES_MODULE + LOAD_HISTORY_BY_ID);
export const loadHistoryByIdSuccessful = createAction(ZONES_MODULE + LOAD_HISTORY_BY_ID + SUCCESSFUL);
export const loadHistoryByIdFailed = createAction(ZONES_MODULE + LOAD_HISTORY_BY_ID + FAILED);
